import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { IssuesPage } from '../../pages/issues';
import { issueFiltersToSearch, parseIssueFilters } from '../../features/issue-filters';
import { useSession } from '../../entities/session';

export const Route = createFileRoute('/_shell/issues/')({
  validateSearch: (search: Record<string, unknown>) => search,
  component: function IssuesRoute() {
    const search = Route.useSearch();
    const navigate = useNavigate();
    const session = useSession();

    return (
      <IssuesPage
        filters={parseIssueFilters(search)}
        timeZone={session.data?.preferences.timezone}
        onFilters={(next) => void navigate({ to: '/issues', search: issueFiltersToSearch(next) })}
        onOpen={(issue) => void navigate({ to: '/issues/$issueId', params: { issueId: issue.id } })}
      />
    );
  },
});
